import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import api from './api';
import { AppThunk } from './app';
import API_URL from '../config/ApiUrl';

interface StarProviderState {
  status: [];
  privilegesList: [];
  rolesList: [];
}

const initialState = {
  status: [],
  // privilegesList: [],
  // rolesList: [],
} as StarProviderState;

const StarProviderSlice = createSlice({
  name: 'StarProvider',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    // setPrivilegesList: (state, action: PayloadAction<any>) => {
    //   state.privilegesList = action.payload;
    // },
    // setRolesList: (state, action: PayloadAction<any>) => {
    //   state.rolesList = action.payload;
    // },
  },
});

export const { setStatus } = StarProviderSlice.actions;

export const fetchAddStarProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.STAR_PROVIDER.ADD, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListStarProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.STAR_PROVIDER.LIST, payload);
      return Promise.resolve(response.data.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchEditStarProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.STAR_PROVIDER.EDIT, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchDeleteStarProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.STAR_PROVIDER.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };


export default StarProviderSlice.reducer;
